<div 
  class="masthead-centered -container d-flex" 
  [ngStyle]="{ 'background-image': 'url(' + backgroundimage + ')' }">
  <div class="row" [ngClass]="backgroundimage ? 'row -home' : 'row'">
    <div class="col-sm-12 -no-padding">
      <div class="masthead-centered -contentContainer">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  
  <button-icon
    icon="dropdown"
    iconattributes="-round -xlg"
    iconcolor="-colorPrimaryGreen"
    backgroundcolor="-backgroundTintPrimaryBlackT60 -opacity"
    backgroundhovercolor="-backgroundSupportingWhite -opacity"
    (click)="scrollDown()"
    class="masthead-centered -buttonScrollDown">
  </button-icon>
  <img *ngIf="image !== undefined" class="masthead-centered -image" [src]="image"/>
</div>